module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "sp-wrap-cards"
  }, [_c('div', {
    staticClass: "sp-top-header padding-top-10 padding-bottom-10 padding-left-10",
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [_c('div', {
    staticClass: "sp-top-header-top"
  }, [((_vm.edit_mode && (_vm.visitor_url != ''))) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "5em",
      "height": "1em"
    },
    on: {
      "click": _vm.syncset
    }
  }, [_vm._v("Back to " + _vm._s(_vm.visitor_app))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-menu-left-bar"
  }, [_c('menu-left-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_vm._m(0), _vm._v(" "), (_vm.sellpoint.business_name != undefined) ? _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("| "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_group_id > 0) ? _c('div', [_c('a', {
    staticStyle: {
      "font-size": "10px",
      "color": "#b13504"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_market_group_username
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.sellpoint.business_market_group))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-search-menu hidden-xs"
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_data),
      expression: "search_data"
    }],
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    },
    domProps: {
      "value": (_vm.search_data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_data = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchProductsByBusiness
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-mobile-menu"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-wrap-card-full",
    staticStyle: {
      "padding": "0 0 0 0.7em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sp-wrap-card-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em",
      "margin-left": "-2em",
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "bottombar-panel",
    attrs: {
      "id": "mobileBottomBar"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closeMobileBottomBar
    }
  }, [_vm._v("X")]), _vm._v(" "), (_vm.bottombar_search) ? _c('div', [_c('div', {
    staticClass: "sp-search-menu",
    staticStyle: {
      "width": "85%",
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_data),
      expression: "search_data"
    }],
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    },
    domProps: {
      "value": (_vm.search_data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_data = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchProductsByBusiness
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.mobileBottomBarActions('display-search-bar', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Search")])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "-7px"
    },
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Timeline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _c('br'), _c('span', [_vm._v("Cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort"
  }), _c('br'), _c('span', [_vm._v("Sort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _c('br'), _c('span', [_vm._v("Chat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac01950"}!./src/pages/Buypoint/Buypoint/template.html
// module id = 280
// module chunks = 0